module.exports = __webpack_public_path__ + "static/coach-hire-services-school-trips-b4003b3b208d7536d8917caecf212449.jpg";